module.exports = __webpack_public_path__ + "img/title_group.41ae9361.png";